import styled from 'styled-components';
import * as SliderPrimitive from '@radix-ui/react-slider';

export const StyledSlider = styled(SliderPrimitive.Root)`
  position: relative;
  display: flex;
  align-items: center;
  height: 6px;
`;

interface StyledTrackProps {
  disabled?: boolean;
}

export const StyledTrack = styled(SliderPrimitive.Track)<StyledTrackProps>(
  ({ theme, disabled }) => ({
    backgroundColor: disabled ? theme.colors.neutral['300'] : theme.colors.neutral['200'],
    position: 'relative',
    flexGrow: 1,
    borderRadius: 3,
    height: '100%',
  }),
);

interface StyledRangeProps {
  disabled?: boolean;
}

export const StyledRange = styled(SliderPrimitive.Range)<StyledRangeProps>(
  ({ theme, disabled }) => ({
    position: 'absolute',
    backgroundColor: disabled ? theme.colors.neutral['400'] : theme.colors.primary['500'],
    borderRadius: 3,
    height: '100%',
  }),
);

interface StyledThumbProps {
  $disabled?: boolean;
}

export const StyledThumb = styled(SliderPrimitive.Thumb)<StyledThumbProps>(
  ({ theme, $disabled }) => ({
    all: 'unset',
    display: 'block',
    border: `1px solid ${theme.colors.neutral['300']}`,
    borderRadius: theme.radii.full,
    width: 20,
    height: 20,
    backgroundColor: $disabled ? theme.colors.neutral['300'] : theme.colors.bg,
    boxShadow: theme.shadows['500'],

    '&[data-focus-visible-added]:focus': {
      boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}`,
      borderColor: theme.colors.primary['500'],
      zIndex: 1,
    },
  }),
);
